<template>
  <!-- 即時影像 -->

  <div class="row g-2 mb-2">
    <div class="col-12">
      <div class="card card-clean h-100">
        <div class="card-header bg-white border-0 fw-bold text-indigo h5">
          即時影像
        </div>
        <div class="card-body p-2" ref="panel" :style="{height: cardBodyHeight}">

          <div style="width: auto; " :style="{height: height}">
          <!-- <div style="width: auto;  height: calc(100vh - 20px);"> -->

            <matrix :groupData="streamings" :panelWidth='panelWidth'></matrix>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import { mapState, mapGetters } from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import Matrix from "../../components/Matrix.vue"
import MobileDetect from '../../utils/mobileDetect'



export default {
  components: {
    Matrix
  },
  props: ['selectedScenicAreaId'],
  watch: {
    selectedScenicAreaId() {
      this.setStreamings()
    },
    streamings() {
      this.isMobileDevice = MobileDetect.isMobileDevice()
      this.height= this.isMobileDevice ? 'calc('+(this.streamings.length)*280 +'px)' :    //'calc('+(this.streamings.length/5)*200 +'vh)' :
          this.streamings.length <= 2 ? 'calc(75vh)' : // 加路蘭只有兩台攝影機
          window.innerHeight > 900 ? 'calc(75vh)' : 'calc(150vh)';

      this.cardBodyHeight = this.isMobileDevice ? 'calc('+((this.streamings.length)*280+300) +'px)' : ''
    }
  },
  data() {
    return {
      streamings: [],
      
      panelWidth: null,
      resizeInterval: null,
      isMobileDevice: false,
      height: window.innerHeight > 900 ? 'calc(75vh)' : 'calc(150vh)',
      cardBodyHeight: '',
    };
  },
  methods: {
    async setStreamings() {
      this.streamings = []
      console.log('this.selectedScenicAreaId', this.selectedScenicAreaId)
      await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', {id: this.selectedScenicAreaId})
      this.streamings = this.$store.getters['getScenicAreaVideoCamera'].filter(vc => vc.isDisabled === false)
      console.log('streams: ',this.streamings)
      
    },

    getHeight() {
      return this.isMobileDevice ? 'calc('+(this.streamings.length)*280 +'px)' :    //'calc('+(this.streamings.length/5)*200 +'vh)' :
          this.streamings.length <= 2 ? 'calc(75vh)' : // 加路蘭只有兩台攝影機
          window.innerHeight > 900 ? 'calc(75vh)' : 'calc(150vh)';
    },

    handleResize() {
      this.height = this.getHeight()
      this.panelWidth = this.$refs.panel.clientWidth
      
    },
  },

  created() {
    window.addEventListener("resize", this.handleResize);
  },
  async mounted() {
    this.setStreamings()
    this.resizeInterval = setInterval(async () => {
      // this.handleResize();
    }, 1000);
    
  },
  destroyed(){
    // if (this.resizeInterval) clearInterval(this.resizeInterval);
    // this.resizeInterval = null;
    window.removeEventListener("resize", this.handleResize);

  },
};
</script>
    